// tslint:disable
export var EnrollmentEligibility;
(function (EnrollmentEligibility) {
    // didn't even try
    EnrollmentEligibility[EnrollmentEligibility["Undetermined"] = 0] = "Undetermined";
    // yes
    EnrollmentEligibility[EnrollmentEligibility["Passed"] = 1] = "Passed";
    // no
    EnrollmentEligibility[EnrollmentEligibility["Failed"] = 2] = "Failed";
})(EnrollmentEligibility || (EnrollmentEligibility = {}));
EnrollmentEligibility['UNDETERMINED'] = 0;
EnrollmentEligibility['PASSED'] = 1;
EnrollmentEligibility['FAILED'] = 2;
//# sourceMappingURL=EnrollmentEligibility.js.map